import { Box } from '@mui/material';
import { ReactNode } from 'react';

interface CallInsightsLayoutProps {
    questionsContent: ReactNode;
    filtersContent: ReactNode;
}

const CallInsightsLayout: React.FC<CallInsightsLayoutProps> = ({ questionsContent, filtersContent }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                gap: 2,
                flexDirection: {
                    xs: 'column',
                    lg: 'row',
                },
                '@container (max-width: 700px)': {
                    flexDirection: 'column',
                },
            }}
        >
            <Box
                sx={{
                    flex: 1,
                    order: {
                        xs: 2,
                        lg: 1,
                    },
                    '@container (max-width: 700px)': {
                        order: 2,
                    },
                }}
            >
                {questionsContent}
            </Box>
            <Box
                sx={{
                    width: {
                        xs: '100%',
                        lg: '200px',
                    },
                    order: {
                        xs: 1,
                        lg: 2,
                    },
                    '@container (max-width: 700px)': {
                        order: 1,
                        width: '100%',
                    },
                }}
            >
                {filtersContent}
            </Box>
        </Box>
    );
};

export default CallInsightsLayout;
